import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../web/components-v2/Theme/theme';

const { spacing, common, typography, colors } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		marginBottom: spacing.md,
	},
	content: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		border: common.border,
		borderRadius: common.borderRadius,
		width: 315,
		height: 90,
		padding: spacing.lg,
	},
	iconContainer: {
		width: 40,
		height: 40,
		marginRight: spacing.md,
	},
	textContainer: {
		flex: 1,
	},
	label: {
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
		marginBottom: spacing.xs,
	},
	subLabel: {
		fontSize: typography.fontSizes.sm,
		color: colors.text.light,
		margin: 0,
	},
	footer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginTop: spacing.sm,
	},
	dateContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.xs,
		fontSize: typography.fontSizes.sm,
		color: colors.text.light,
		'> svg': {
			marginRight: spacing.xs,
			width: 16,
			height: 16,
		},
	},
	button: {
		maxHeight: 26,
		minWidth: 120,
	},
	buttonStyleTrigger: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		position: 'relative',
		gap: spacing.sm,
		backgroundColor: colors.primary.main,
		color: colors.primary.contrastText,
		border: 'none',
		borderRadius: common.borderRadius,
		padding: `${spacing.xs}px ${spacing.sm}px`,
		fontSize: typography.fontSizes.sm,
		fontFamily: typography.fontFamilies.lexend,
		cursor: 'pointer',
		minWidth: 120,
		height: 26,
		boxShadow: '0 1px 2px 0 rgba(140,140,140,0.50)',
		transition: 'color .5s, background-color .5s',
		':hover': {
			backgroundColor: colors.primary.light,
		},
		':disabled': {
			backgroundColor: colors.primary.main,
			cursor: 'not-allowed',
		},
	},
	triggerChevron: {
		fontSize: typography.fontSizes.xs,
		position: 'absolute',
		right: spacing.sm,
		transform: 'rotate(90deg)',
		transition: 'transform 0.2s ease-in-out',
	},
	triggerChevronRotated: {
		transform: 'rotate(270deg)',
	},
	triggerText: {
		width: '100%',
		textAlign: 'center' as const,
		paddingRight: spacing.lg,
	},
	compactDropdownContent: {
		minWidth: 'fit-content',
		width: 'auto',
	},
	substep: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
	},
	substepLabel: {
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		margin: `${spacing.xs}px 0`,
	},
	substepStatus: {
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
		margin: 0,
	},
});
